
import { useAuth } from '@/contexts/AuthContext';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { PEODashboardHeader } from './PEODashboardHeader';
import { PEOProviderProfile } from './PEOProviderProfile';
import { PEODashboardContent } from "@/components/peo/dashboard/PEODashboardContent";
import { usePEOProviderData } from "@/components/peo/dashboard/usePEOProviderData";
import { PEODashboardLoader } from "./PEODashboardLoader";
import { useNavigate } from "react-router-dom";
import { AuthDiagnostics } from "@/components/debug/AuthDiagnostics";

/**
 * The main PEO Dashboard page with improved authentication handling.
 */
const PEODashboard = () => {
  const { logout, userRole, isLoading: authLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [authCheckComplete, setAuthCheckComplete] = useState(false);
  const {
    loading,
    providerInfo,
    isEditing,
    setIsEditing,
    form,
    setForm,
    handleSave,
    saving,
  } = usePEOProviderData();

  // Handle authentication check
  useEffect(() => {
    console.log('PEO Dashboard: Auth state check', { 
      authLoading, 
      isAuthenticated, 
      userRole 
    });

    if (!authLoading) {
      if (!isAuthenticated) {
        console.log('PEO Dashboard: Not authenticated, redirecting to login');
        navigate('/login');
        return;
      }
      
      if (userRole !== 'peo') {
        console.log('PEO Dashboard: Not a PEO user, redirecting to dashboard');
        navigate('/dashboard');
        return;
      }
      
      // Mark auth check as complete for PEO users
      setAuthCheckComplete(true);
    }
  }, [authLoading, isAuthenticated, userRole, navigate]);

  // Show loader while checking authentication or loading provider data
  const shouldShowLoader = authLoading || !authCheckComplete || loading;

  if (shouldShowLoader) {
    return <PEODashboardLoader />;
  }

  // Handles dashboard manual refresh
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="space-y-6">
      <PEODashboardContent
        loading={loading}
        onRefresh={handleRefresh}
        onLogout={logout}
        providerInfo={providerInfo}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        form={form}
        setForm={setForm}
        onSave={handleSave}
        saving={saving}
      />
    </div>
  );
};

export default PEODashboard;
